const readinessItems = [
  {
    title: 'Servicepagina’s',
    status: 'Vooraf lezen',
    copy: 'Algemene voorwaarden, privacy, cookies, retouren, garantie en productveiligheid staan klaar zodat je weet welke afspraken straks gelden.'
  },
  {
    title: 'Verzending en retouren',
    status: 'NL/BE basis',
    copy: 'We werken met duidelijke verzend- en retourinformatie voor Nederland en Belgie. Grote pakketten, zoals netten of clubsets, krijgen extra uitleg.'
  },
  {
    title: 'Productinformatie',
    status: 'Per artikel',
    copy: 'Bij verkoop tonen we per product de belangrijkste specificaties, gebruikssituatie, foto’s en praktische verwachtingen.'
  },
  {
    title: 'Veilig gebruik',
    status: 'Uitleg per categorie',
    copy: 'Ballen, netten, grips, schoenen en bescherming krijgen praktische gebruiksinformatie voordat ze bestelbaar worden.'
  },
  {
    title: 'Privacy en cookies',
    status: 'Jij kiest',
    copy: 'Noodzakelijke cookies houden de site werkend. Analytics en marketing staan uit totdat je toestemming geeft.'
  },
  {
    title: 'Bestellen',
    status: 'Opent later',
    copy: 'Online bestellen gaat pas open wanneer betalen, leveren, retourneren en productinformatie volledig zijn ingericht en getest.'
  }
];

export function ReadinessSection() {
  return (
    <section className="section readiness" id="readiness">
      <p className="eyebrow">Service & zekerheid</p>
      <h2>Je kunt alvast producten bekijken; bestellen opent zodra alles klopt.</h2>
      <p className="sectionIntro">
        ProPickleball.nl start met productinformatie, prijsindicaties en pakketvragen. Zo kun je nu al kiezen en ontvang je bericht zodra de eerste verkoopbatch klaarstaat.
      </p>
      <div className="readinessGrid">
        {readinessItems.map((item) => (
          <article key={item.title} className="readinessCard">
            <span>{item.status}</span>
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
